import axios, { AxiosRequestConfig } from 'axios';
import { pretension } from '@/utils/config';

// X-Actor нужен для frontend-инициированных действий через Talend, где PHP пишет автора/changed_by:
//   - 6 status-change роутов (аудит status changes, CS-C);
//   - создание претензии create (отправка) — PHP выводит created_by_email/changed_by из X-Actor;
//     без него created_by_email=null и changed_by='system'.
// Пути через шлюз session_me (черновики, startSigning, document-link) X-Actor не шлют: шлюз его
// не пересылает, автора PHP берёт из сессии (задача 12003). НЕ для read-only (/list, /single).
// Whitelist предотвращает collateral CORS preflight на endpoints, для которых backend
// allow-headers может не пропускать X-Actor (см. FML-byr0/FML-hado).
//
// ВНИМАНИЕ: create матчится ТОЧНЫМ путём (не startsWith): pretension.create
// (`${talendEndpoint}/pretension`) — префикс для /list,/single,/update,/status/*, startsWith
// протёк бы X-Actor на read-only/CRUD-роуты.
const ACTOR_PREFIX_URLS: readonly string[] = Object.freeze([
  ...Object.values(pretension.status),
]);

const ACTOR_EXACT_URLS: readonly string[] = Object.freeze([
  pretension.create,
]);

function requiresXActor(url: string): boolean {
  const path = url.split('?')[0];
  if (ACTOR_EXACT_URLS.includes(path)) {
    return true;
  }
  // startsWith — резервируем возможность query-string'а на status/PUT-роутах.
  return ACTOR_PREFIX_URLS.some((u) => url.startsWith(u));
}

// store типизирован как `{ state: any }` намеренно: реальный Vuex Store<RootState>
// в этом проекте не объявляет profile в RootState (он подключён как namespaced module,
// доступен в runtime, но отсутствует в статическом типе). Структурный {state: any}
// совместим со Store<RootState> и оставляет access optional-chaining'у внутри.
export default (store?: { state: any }) => {
  // request interceptor
  axios.interceptors.request.use((config: AxiosRequestConfig) => {
    const authToken = localStorage.getItem('authToken');
    const { headers } = config;
    headers.withCredentials = true;
    headers.credentials = 'include';
    headers.authorization = authToken;

    if (store && typeof config.url === 'string' && requiresXActor(config.url)) {
      const email = store.state?.profile?.session?.user_pimcore?.email;
      if (email) {
        headers['X-Actor'] = email;
      }
    }

    return config;
  }, (error) => Promise.reject(error));

  // response interceptor
  // axios.interceptors.response.use((response: AxiosResponse) => {
  //   return response;
  // }, (error) => Promise.reject(error));
};
